<template>
	<label class="radio-container">
		{{label}}
		<input
			:class="{  'is-invalid': ( Object.keys( validation ).length > 0 && ( validation.hasOwnProperty( 'required' ) || !validation.requiredIf ) && this.validation.$invalid ) ? true : false }"
			type="radio"
			:id="id"
			:value="value ? value : label"
			@change="$emit('update:current_value', $event.target.value)"
			:disabled="disabled != ''"
			:required="required"
			:checked="current_value == ( value ? value : label )"
		/>
		<span class="radio-checkmark" :for="id"></span>
		<validation :v="validation" />
	</label>
</template>

<script>
import Misc from '@/services/Misc';

import Validation from './Validation.vue';

export default {
	name: 'FormRadio',
	components: {
		Validation,
	},
	props: {
		label: {
			type: String,
			required: false,
		},
		value: {
			required: false,
		},
		current_value: {
			required: true,
		},
		disabled: {
			type: String,
			required: false,
			default: '',
		},
		required: {
			type: Boolean,
			required: false,
			default: false,
		},
		validation: {
			type: Object,
			required: false,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			Misc,
			id: Misc.generageRandomString(),
		};
	},
	computed: {
		isValid() {
			if (this.validation.length > 0 && this.validation.$invalid) {
				return true;
			} else if (this.validation.length > 0 && !this.validation.$invalid) {
				return false;
			}

			return false;
		},
		isRequired() {
			if (
				Object.keys(this.validation).length > 0 &&
				(this.validation.hasOwnProperty('required') || !this.validation.requiredIf)
			) {
				return ' <span class="required">*</span>';
			}

			return '';
		},
	},
};
</script>
